import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-package-form',
    templateUrl: './package-form.component.html',
    styleUrls: ['./package-form.component.less'],
    standalone: false
})
export class PackageFormComponent implements OnInit {

  packageForm: FormGroup;
  packageTypes:any;
  yesNoList = this.utilityService.getYesNoList();
  showStatus:string;
  showDeactivateToggle=false;
  showReactivateToggle=false;
  checked:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  editPermission:boolean=false;
  addPermission:boolean = false;

  constructor( private formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dailogRef : MatDialogRef<PackageFormComponent>,
              private service:DataService,
              private utilityService: UtilityService,
              private dailog:MatDialog,
              private router:Router,
              private permissionService:PermissionService) 
              { this.dailogRef.disableClose=true; }

ngOnInit(): void {
  this.checkAllPermission();
  this.initializePackageForm();
  this.getTypes();
  this.patchValue();
}

private initializePackageForm(){
  this.packageForm = this.formBuilder.group({
    id:[],
    name:[null,[Validators.required]],
    type:[null,[Validators.required]],
    wooden:[null,[Validators.required]],
    status:[],
  });
}

private getStatus(data: any) {
if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
else if (data.status == "DEACTIVATED" && !data.submittedForApproval && this.reactivatePermission) {
    this.showReactivateToggle=true;
    return "Deactivated...";
} else {
    return this.utilityService.getApprovalMessage({status:data.status,
      submittedForApproval: data.submittedForApproval,
      deactivationWefDate: data.detactivate?.deactivationWefDate,
      reactivationWefDate: data.reactivate?.reactivationWefDate});
}
}

private patchValue() {
  if (this.data?.id) {
        this.showStatus = this.getStatus(this.data);
        this.packageForm.patchValue(this.data);
          if(this.data.status == 'DEACTIVATED'){
            this.packageForm.disable();
    }
  }
}

getTypes(){
  this.service.get(Api.PACKAGE_TYPES, this.packageForm).subscribe(res => {
      if(res){
        this.packageTypes=res;
      }
  })
}

private openDailog(message:string, onConfirm:() => void){
  const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
      data:message,
      maxWidth:"300px",
      maxHeight:"150px"
    });

  dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult===false){
        return;
      }
      else {
        onConfirm();
      }
  })
}

public cancel() {
  if(this.packageForm.dirty)
  {
    this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT, () => {
      this.router.navigate([APP_ROUTES.PACKAGE_LIST]);
      this.dailogRef.close();
    });
  }
  else{
    this.router.navigate([APP_ROUTES.PACKAGE_LIST]);
    this.dailogRef.close();
  }
}

public save() {
  this.packageForm.markAllAsTouched();
  if(this.packageForm.valid)
  {
    if(this.id.value){
    this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT, () => this.savePackageModule());
    }
    else {
      this.openDailog(Message.SAVE_OPEN_DAILOG, () => this.savePackageModule());
    }
  }
}

savePackageModule()
  {
    this.packageForm.markAllAsTouched();
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.packageForm.valid){
      this.name.patchValue(this.name.value.trim().replace(/ +/g, ' '));
      this.service[method](Api.PACKAGE, this.packageForm.value).subscribe(res => {
        this.utilityService.notifier('package Details '+message+' successfully', 'success');
        this.router.navigate([APP_ROUTES.PACKAGE_LIST]);
        this.dailogRef.close();
      });
    }
  }

openDeactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,message:'Package',api:Api.DEACTIVATE_PACKAGE,isReasonMandatory:false,route:APP_ROUTES.PACKAGE_LIST}
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
  })
}

openReactivateForm(e:MatSlideToggleChange)
{
  let data={id:this.id.value,message:'Package',api:Api.REACTIVATE_PACKAGE,isReasonMandatory:false,route:APP_ROUTES.PACKAGE_LIST}
  const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
  dailogRef.afterClosed().subscribe(value => {
    this.checked = !this.checked;
  })
}

public checkAllPermission(){
  let permissionCodes=[PermissionKey.PACKAGE_MODULE_EDIT_PERMISSION,PermissionKey.PACKAGE_MODULE_ADD_PERMISSION];
  let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.PACKAGE_MODULE);
  // this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
  // this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
  this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_EDIT_PERMISSION})?.show?true:false;
  this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_ADD_PERMISSION})?.show?true:false;
}

  get id(){return this.packageForm.get('id')};
  get name(){return this.packageForm.get('name')};
  get type(){ return this.packageForm.get('type')};
  get wooden(){ return this.packageForm.get('wooden')};
  get status(){ return this.packageForm.get('status')};

}
